import { FC } from "react";
import {
  selectMainState,
  setIdTrack,
  setPlayTrack,
  setViewAudioPlayer,
} from "../../../../../store/slices/main";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../hooks/redux-hooks";
import AudioPlayer from "../audioPlayer/AudioPlayer";
import InfoTrack from "../../radioPlayer/widgetRadioPlayer/components/InfoTrack";
import LikePlayer from "../../../../../assets/icon/LikePlayer";
import Close from "../../../../../assets/icon/Close";

interface Props {
  metadata?: string;
  cover?: string;
  defaultCover?: string;
  trackName?: string;
  artist?: string;
  isLiked?: boolean;
}

const DesctopPlayer: FC<Props> = ({
  cover,
  defaultCover,
  trackName,
  artist,
  isLiked,
}) => {
  const dispatch = useAppDispatch();
  const { audioPlayer } = useAppSelector(selectMainState);

  const handleClose = () => {
    dispatch(setPlayTrack(false));
    dispatch(
      setIdTrack({
        idTrack: "",
        cover: "",
        trackLink: "",
      })
    );
  };

  return (
    <div
      className={
        audioPlayer.overTop
          ? "fixed w-full bottom-0 left-0 min-h-[4rem] bg-bg_player flex justify-center items-center opacity-[85%]"
          : "min-h-[4rem] px-2 flex justify-center items-center"
      }
    >
      <div className="w-full flex justify-center items-center max-w-[60rem] pxa-1 z-40 sm:flex-row-reverse">
        <div className="w-[16rem] pl-7 flex justify-center md:pr-10 items-center sm:w-[20.5rem]">
          <div
            className="w-full flex justify-start items-center md:justify-center"
            // onClick={() => {
            //   audioPlayer.overTop
            //     ? dispatch(setViewAudioPlayer(true))
            //     : dispatch(setViewAudioPlayer(false));
            // }}
          >
            <InfoTrack
              cover={defaultCover}
              coverTrack={cover}
              trackName={trackName}
              artist={artist}
            />
            {/* <div className="hidden md:block pl-4 pr-5 md:ml-[5rem]">
              <LikePlayer isLiked={isLiked} />
            </div> */}
          </div>
        </div>
        <div className="desctop-player w-[33rem] flex justify-center items-center ">
          <div className="w-full max-w-[35rem] flex justify-center items-start ">
            <div className="w-full flex justify-start relative md:pl-3">
              <div className="absolute top-[13px] right-[70px] pl-4 pr-5 z-[100] sm:hidden ">
                <LikePlayer isLiked={isLiked} />
              </div>
              <AudioPlayer type={"desctop"} />
              {/* <div className="desctop-button desctop-button_left cursor-pointer">
                <Prev />
              </div>
              <div className="desctop-button desctop-button_right cursor-pointer">
                <Next />
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <button
        className="cursor-pointer z-50 block absolute top-2 md:right-2 right-1 p-0.5 hover:bg-black hover:bg-opacity-[4%] rounded-full"
        onClick={() => {
          handleClose();
        }}
      >
        <Close width="w-4" height="h-4" />
      </button>
    </div>
  );
};

export default DesctopPlayer;
